import { Navigate } from 'react-router-dom'

/** AlertRules is now embedded in the Alerts page as a tab.
 *  This component redirects old /funnels/alerts/rules URLs to the tabbed view. */
export default function AlertRules() {
  return <Navigate to="/funnels/alerts?tab=rules" replace />
}
